import React from 'react'
import PieChartPanel from '../../../components/Charts/PieChartPanel';
import FilterPanel from '../components/FilterPanel';
import PieLegend from '../components/PieLegend';

const WinReportByMix = () => {
  return (
    <div className='p-2'>
      <div className='flex justify-between border-b border-b-gray-300 pb-2'>
        <h6 className="font-semibold">Win Report By Mix</h6>
        <FilterPanel />
      </div>
      <div className='flex flex-col items-center'>
        <div className="w-[70%] h-[200px]">
          <PieChartPanel _data={data}/>
        </div>
        <PieLegend _data = {data}/>
      </div>
    </div>
  )
}

export default WinReportByMix;

const data = [
  {
    "name": "2 Mix",
    "value": 500000
  },
  {
    "name": "3 Mix",
    "value": 300000
  },
  {
    "name": "4 Mix",
    "value": 100000
  },
  {
    "name": "5 Mix",
    "value": 340000
  },
  {
    "name": "6 Mix",
    "value": 500000
  },
  {
    "name": "7 Mix",
    "value": 300000
  },
  {
    "name": "8 Mix",
    "value": 100000
  },
  {
    "name": "9 Mix",
    "value": 340000
  }
]